module.exports = __webpack_public_path__ + "static/img/早班組長-李佳壕.80e5521.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/早班組長-李佳壕.jpg
// module id = bwSh
// module chunks = 1